// extracted by mini-css-extract-plugin
export default {"radarBox":"NewScorePageContent_radarBox__A3p1X","topTextSection":"NewScorePageContent_topTextSection__jMv1R"};